import { render } from "./ClientRequirementsCustomizer.vue?vue&type=template&id=2055ab7d&scoped=true"
import script from "./ClientRequirementsCustomizer.vue?vue&type=script&lang=js"
export * from "./ClientRequirementsCustomizer.vue?vue&type=script&lang=js"

import "./ClientRequirementsCustomizer.vue?vue&type=style&index=0&id=2055ab7d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2055ab7d"]])

export default __exports__